module.exports = __webpack_public_path__ + "static/img/page_bg.9f05464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/page_bg.png
// module id = hFFL
// module chunks = 1